module.exports = "/_next/static/images/9aa51d8b1d227107eec2110cb123f970-card.svg";